module.exports = __webpack_public_path__ + "asset/image-business-aa192167e564208d.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/component/plans/component/plan/image/business.png
// module id = 494G
// module chunks = 3